export default __webpack_public_path__ + "static/media/Group8412.3dcea877.svg";